<template>
  <admin-layout title="Calendário" menu="calendario">
    <Calendar />
  </admin-layout>
</template>

<script>
import Calendar from 'components/Calendar.vue'
export default {
  components: { Calendar }
};
</script>
